import { render, staticRenderFns } from "./PayerSettingsRow.vue?vue&type=template&id=2ec64d9c&scoped=true"
import script from "./PayerSettingsRow.vue?vue&type=script&lang=js"
export * from "./PayerSettingsRow.vue?vue&type=script&lang=js"
import style0 from "./PayerSettingsRow.vue?vue&type=style&index=0&id=2ec64d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec64d9c",
  null
  
)

export default component.exports